<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>

    <vs-card>
      <div slot="header">
        <vs-title>Etkinlik Talep / Şikayet Oluşturma Ekranı</vs-title>
         
      </div>
     
      <div v-if="! saved">
      <vs-button  :style="'margin-left:90%'" color="#1f74ff" :to="{name: 'prequest'}" >İleri</vs-button>
      <br/>
          <br/>
            <br/>
       <vs-input id="deneme2"  disabled label="Formun doldurulacağı etkinlik" class="inputx" placeholder="Etkinlik Seçiniz" v-model="this.etkinlikAdi"/>
        <br/>
          <br/>
            <br/>
     <vs-select
            placeholder="Öneri/Talep Türü"
            label-placeholder="Autocomplete"
            class="d-inline-block"
            autocomplete
              
            v-model="obj.columns.suggestRequest"
            >
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in combobox" />
          </vs-select>
        <br/>
 <br/>
         <br/>
       <vs-textarea
          label="Açıklama"
            v-model="obj.columns.reqq"
            name="author"
            
        />
        *Öneri/Talep/Şikayet açıklaması yazınız.
       <br/>
         <br/>
         <div class="container">
        <form @submit.prevent="handleSubmit"> 
            <div class="form-group">
                <input type="file" @change="uploadFile" multiple>
            </div>

            <div class="form-group">
                <button class="btn btn-success  btn-lg">Dosya Gönder</button>
            </div>
        </form>
    </div>    
         
        <vs-error :errors="errors"></vs-error>
        <br>
        <br>
        <br>
        <br>
        <vs-button  color="#46c93a" @click="save">Form Gönder</vs-button>
      </div>

      <div v-else>
        <h4>Öneri / Şikayet'iniz alındı!</h4>

       <vs-button type="gradient" color="success" :to="{name: 'prequest'}" >Dön</vs-button>
      </div>

    </vs-card>

  </div>
</template>

<script>
  import Reqq from "@/libs/reqqs/Reqq";
  import Folder from "@/libs/folders/Folder";
  
  export default {
    name: "reqqs-create",
    title: "Add A Reqq",
    data() {
      return {
        obj: new Reqq(),
        obj2: new Folder(),
        loading: false,
        etkinlikAdi:'',
        birim:'',
        combobox:[
        {text: 'Öneri', value: 'Öneri'},
        {text: 'Talep', value: 'Talep'},
         {text: 'Şikayet', value: 'Şikayet'}
        
       
      ],
      };
    },
    computed: {
      saved() {
        return this.obj.saved
      },
      submitted() {
        return this.obj.form.submitted
      },
      contaminated() {
        return this.obj.form.errorDetected
      },
      errors() {
        return this.obj.form.errors
      }
    },
    watch: {
      contaminated(val) {
        this.loading = false
      },
      submitted(val) {
        if(val)
          this.loading = false
      },
      saved(val) {
        if(val) {
          // handle added
        }
      },
    },
    methods: {
      uploadFile (event) {
        this.files = event.target.files
        },
         handleSubmit() {
          const formData = new FormData();
          for (const i of Object.keys(this.files)) {
            formData.append('files', this.files[i])
            
            var file = this.files[i];  
           var filename = file.name;
           filename=filename.toLowerCase().split(' ').join('-');
           console.log(filename)
          }
           formData.append('directory', this.etkinlikAdi)
           formData.append('dclass', 'etkinlik_bilgisi')
          this.obj2.columns.folder= this.etkinlikAdi+'&&&&&'+'dilek_sikayet'+'&+&+&'+filename
           this.obj2.create()
          axios.post('https://eys.hacibayram.edu.tr:8081/api/file-upload', formData, {
          }).then((res) => {
            console.log(res)
          })
        },
      save() {
        this.loading = true
         this.obj.columns.eventName=this.etkinlikAdi
          this.obj.columns.birim=this.birim
          
        this.obj.create()
      },
      
      addNew() {
        this.obj.reset();
        this.obj.saved = false
      }
    },
    mounted() {
      this.etkinlikAdi= this.$route.params.id
      this.birim= this.$route.params.name
      this.obj.reset();
    }
  };
</script>

<style>
#deneme2{
  font-weight: bold;
  color:red;
  font-size: 14px; 
}
</style>